import script from "./cau-hinh-truy-van.vue?vue&type=script&setup=true&lang=js"
export * from "./cau-hinh-truy-van.vue?vue&type=script&setup=true&lang=js"

import "./cau-hinh-truy-van.vue?vue&type=style&index=0&id=01207bbf&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01207bbf"]])

export default __exports__